import { IoMdPrint } from "react-icons/io";
import PrintPayablesPlan from "./PrintPayablesPlan";
import { useRef } from "react";
import {
  getAllPartnersBySearchParams,
  resetPartnerPlansPayable,
  resetPartnerPlansReceivable
} from "../main.slice";
import { useAppDispatch } from "hooks/hooks";
import PrintReceivablesPlan from "./PrintReceivablesPlan";
import { usePagePrint } from "hooks/usePagePrint";
import { MdCancel } from "react-icons/md";
import { useSelector } from "react-redux";
import { selectState } from "authentication/main.slice";

interface IProps {
  count: number;
};

const TableHeader = ({ count }: IProps) => {
  const componentPayablesPlanRef = useRef<HTMLDivElement>(null);
  const componentReceivablesPlanRef = useRef<HTMLDivElement>(null);
  const handlePrintPayablesPlan = usePagePrint(componentPayablesPlanRef);
  const handlePrintReceivablesPlan = usePagePrint(componentReceivablesPlanRef);
  const { user } = useSelector(selectState);
  const dispatch = useAppDispatch();

  const handleSortBy = (columnName: string) => {
    dispatch(getAllPartnersBySearchParams({ sortBy: columnName }));
  };

  const resetAllReceivablePlans = () => {
    dispatch(resetPartnerPlansReceivable());
  };

  const resetAllPayablePlans = () => {
    dispatch(resetPartnerPlansPayable());
  };

  return (
    <div className="g-grid g-header">
      <div className="row">
        <div />
        <div />
        <div />
        <div />
        <div className="col lowercase">
          ime
          <span className="bg-item bg-item-border-light center">{count}</span>
        </div>
        <div />
        <div />
        <div />
        <div
          className="col capitalize center separator-line clickable"
          onClick={() => handleSortBy("receivablesNextDueDate")}
        >
          Dat valute
        </div>
        <div
          className="col center clickable"
          onClick={() => handleSortBy("receivablesTotalDebtAmount")}
        >
          POTRAŽIVANJA
        </div>
        <div />
        <div
          className="col center separator-line clickable"
          onClick={() => handleSortBy("payablesTotalOutstandingAmount")}
        >
          DUGOVANJA
        </div>
        <div
          className="col center capitalize clickable"
          onClick={() => handleSortBy("payablesNextDueDate")}
        >
          Dat valute
        </div>
        <div className="col center">XXX</div>
        <div className="col center plan">
          <label>Plan Naplate</label>
          <IoMdPrint className="fas" onClick={() => {
            handlePrintReceivablesPlan();
          }} />
          {user?.username === "test" && <MdCancel className="fas" onClick={() => {
            resetAllReceivablePlans();
          }} />}
        </div>
        <div className="col center plan">
          <label>Plan Plaćanja</label>
          <IoMdPrint className="fas" onClick={() => {
            handlePrintPayablesPlan();
          }} />
          {user?.username === "test" && <MdCancel className="fas" onClick={() => {
            resetAllPayablePlans();
          }} />}
        </div>
        <div ref={componentPayablesPlanRef} className="print-area">
          <PrintPayablesPlan />
        </div>
        <div ref={componentReceivablesPlanRef} className="print-area">
          <PrintReceivablesPlan />
        </div>
      </div>
    </div>
  );
};

export default TableHeader;
